module.exports = __webpack_public_path__ + "img/mx.843c2710.svg";